<template>
  <v-card flat class="ma-4" :loading="loading" :disabled="loading">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-form @submit.prevent="submit">
        <v-card-title>
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn @click="getData()" icon>
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert type="info" text>
            Ficheiros com tamanho superior a <b>200MB</b> serão bloqueados pelo
            servidor. <br />
            Para permitir o envio de ficheiros maiores, deverá contactar a
            equipa técnica.
          </v-alert>

          <ValidationProvider
            name="settings.max_attachments_upload_size"
            :rules="`required|min_value:1|max_value:${mbToKb(200)}`"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="__('Tamanho máximo', 'settings')"
              outlined
              type="number"
              dense
              :value="value"
              @input="setValue"
              :error-messages="errors"
              single-line
            >
              <template v-slot:append>
                <span class="mt-1"> KB </span>
              </template>
            </v-text-field>
          </ValidationProvider>

          <v-chip-group
            column
            :value="value"
            @change="setValue"
            active-class="primary--text"
          >
            <v-chip
              v-for="sugestion in items"
              :key="sugestion.value"
              :value="sugestion.value"
              small
            >
              {{ sugestion.text }}
            </v-chip>
          </v-chip-group>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            type="submit"
            color="primary"
            :disabled="invalid"
            elevation="0"
          >
            {{ __("Salvar", "settings") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </ValidationObserver>
  </v-card>
</template>

<script>
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false,
    },
    sugestions: {
      type: Array,
    },
  },

  data() {
    return {
      value: 1,
    };
  },

  methods: {
    async submit() {
      const validation = await this.$refs.form.validate();
      if (!validation) return;

      this.$emit("submit", this.value);
    },
    fill(value) {
      this.value = value;
      this.$refs.form.reset();
    },
    setErrors(errors) {
      this.$refs.form.setErrors(errors);
    },
    getData() {
      this.$emit("reset");
    },
    setValue(value) {
      this.value = value;
    },
    mbToKb(mb) {
      return mb * 1024;
    },
    makeSugestion(mb) {
      return {
        text: `${mb} MB`,
        value: this.mbToKb(mb),
      };
    },
    makeSugestions(values) {
      return values.map((value) => this.makeSugestion(value));
    },
  },

  computed: {
    items() {
      return this.sugestions
        ? this.sugestion
        : this.makeSugestions([1, 5, 10, 20, 50, 100, 150, 200]);
    },
  },
};
</script>
